import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { ReactiveComponent } from "../../entities/base-component";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { Overheads } from "@/app/domain/entities/overhead";

export class OverheadSumWithDiscountCalculationStrategy extends CalculationStrategy {
    calculate = (component: Overheads, [discountPercent]): PriceResult => {
        return {
            price: this.calculateOverheadWithDiscount(component, discountPercent, CostDealType),
            priceB2C: this.calculateOverheadWithDiscount(component, discountPercent, B2CDealType),
            priceB2B: this.calculateOverheadWithDiscount(component, discountPercent, B2BDealType),
        };
    };

    private calculateOverheadWithDiscount(
        component: ReactiveComponent,
        discountPercent: number,
        dealType: string,
    ) {
        if (!component) return 0;
        const activeOverheadSum = component.sum.getSystemPrice(dealType).getValue() || 0;
        const overheadPriceWithDiscount = activeOverheadSum / (100 - discountPercent) * 100

        return +overheadPriceWithDiscount.toFixed(2);
    }
}
